import {FieldValues, ItemDataFieldModel} from 'models/board';
import {MarketPlaceResponseModel, marketPlaceToSettingParser} from 'models/marketplace/matketPlace.model';

export interface SettingsKeyValueResponseModel {
    uniqueId: string;
    value?: FieldValues; // Optional with a default value can be handled during initialization
    dataType: string;
}
export enum SettingsObjectTypeEnum {
    Tenant = 'Tenant',
    Workspace = 'Workspace',
    Board = 'Board',
}
export enum SettingsGroupsEnum {
    Tenant = 'Tenant',
    Workspace = 'Workspace',
    Board = 'Board',
    Webhooks = 'Webhooks',
    Features = 'Features',
    Intergrations = 'Intergrations',
    SlackIntegration = 'SlackIntegration',
}
export interface SettingModel {
    id: string;
    tenantId?: string;
    title: string;
    uniqueId: string;
    objectId?: string;
    objectType: string;
    value?: string;
    groupName?: string;
    controlType: string;
    order: number;
    status: string;
    data?: ItemDataFieldModel[];
    dataType?: string;
    isMulti?: boolean;
    marketPlaceId?: string;
    servers?: string;
}
export interface SettingCreateRequest extends Omit<SettingModel, 'id' | 'status' | 'includedIntegrationsCount'> {}
export interface SettingCreateUpdateRequest extends Omit<SettingModel, 'id' | 'status' | 'includedIntegrationsCount'> {
    id?: string;
}

export interface SettingsUpdateRequest {
    id: string;
    data?: ItemDataFieldModel[];
}

export interface SettingsUpdateRequestModel {
    tenantSlug: string;
    settings: SettingsUpdateRequest[];
}
export enum SettingStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export const settingsModelToCreateUpdateRequestModelForMarketPlace = (
    settings: SettingModel[],
    marketPlace: MarketPlaceResponseModel,
    tanantId: string,
): SettingCreateUpdateRequest[] => {
    if (settings.length === 0) {
        return [marketPlaceToSettingParser(marketPlace, SettingsObjectTypeEnum.Tenant.toString(), tanantId)];
    } else {
        return settings.map((setting, index) => {
            return {
                ...setting,
                order: index + 1,
                marketPlaceId: marketPlace.id,
                data: marketPlace.data?.map(field => ({
                    ...field,
                    value: setting.data?.find(item => item.uniqueId === field.uniqueId)?.value ?? {
                        multiSelectedOptions: [],
                    },
                })),
            };
        });
    }
};
